<template>
  <div>
    <app-drawer
      ref="appDrawer"
      :isBusy="isLoading"
      @close="closeDrawer"
      title="Add damages to ULD"
    >
      <div class="el-drawer__content" v-loading="isLoading">
        <el-form ref="damageForm">
          <el-row
            :gutter="8"
            v-for="(damage, index) in damages"
            :key="`damage_${index}`"
            style="margin-bottom: 15px;"
          >
            <el-col :md="8" :sm="12">
              <el-form-item
                style="margin-bottom: 5px"
                label="Damage Part / Panel"
              >
                <el-select
                  :disabled="!isRole([1, 3, 4])"
                  v-model="damage.damage_part_id"
                  clearable
                  filterable
                  @change="addNewRow"
                >
                  <el-option
                    v-for="item in getAvailableParts()"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12">
              <el-form-item style="margin-bottom: 5px" label="Description">
                <el-select
                  :disabled="!isRole([1, 3, 4])"
                  v-model="damage.damage"
                  clearable
                  filterable
                  @change="addNewRow"
                >
                  <el-option
                    v-for="item in damage_descriptions"
                    :value="`${item.id}`"
                    :key="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12">
              <el-form-item style="margin-bottom: 5px" label="Action Taken">
                <el-select
                  :disabled="!isRole([1, 3, 4])"
                  v-model="damage.action_required"
                  clearable
                  filterable
                  @change="addNewRow"
                >
                  <el-option
                    v-for="item in action_taken"
                    :value="item.value"
                    :key="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12">
              <el-form-item style="margin-bottom: 5px" label="Welder">
                <!-- <el-button
                  size="small"
                  type="primary"
                  @click="assignType(damage, 'welder')"
                  >Assign Welder</el-button
                > -->
                <el-select
                  :disabled="!isRole([1, 3])"
                  v-model="damage.welded_by"
                  clearable
                >
                  <el-option
                    v-for="user in welder"
                    :key="user.id"
                    :label="`${user.first_name} ${user.last_name}`"
                    :value="user.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12">
              <el-form-item style="margin-bottom: 5px" label="Tailor">
                <!-- <el-button
                  size="small"
                  type="primary"
                  @click="assignType(damage, 'tailor')"
                  >Assign Tailor</el-button
                > -->
                <el-select
                  :disabled="!isRole([1, 3])"
                  v-model="damage.tailored_by"
                  clearable
                >
                  <el-option
                    v-for="user in tailor"
                    :key="user.id"
                    :label="`${user.first_name} ${user.last_name}`"
                    :value="user.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="d-flex">
                <AppUploader
                  url="/api/v1/inventory/fileupload/"
                  :params="{ q: 'damages' }"
                  @uploadSuccess="handleUploadSuccess(arguments, damage)"
                  accept="image/*"
                  :multiple="false"
                  :limit="3"
                  :fileList="damage.files"
                  :is-disabled="damage.files.length == 3"
                >
                  <i class="el-icon-upload2"></i>
                </AppUploader>
                <div class="ml-1">
                  <template v-if="isEdit">
                    <div
                      class="d-flex mb-2"
                      v-for="(file, index) in damage.files"
                      :key="`file_${index}`"
                    >
                      <a
                        href="#"
                        class="text-danger"
                        style="margin-right: 5px"
                        @click="deleteFile(damage, file)"
                      >
                        <i class="el-icon-close"></i>
                      </a>
                      <!-- {{ file.name }} -->
                      <img
                        :src="getImageSrc(file)"
                        :alt="file.name"
                        style="max-width: calc(100% - 30px)"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <span
                      class="d-block mr-2"
                      v-for="(file, index) in damage.files"
                      :key="`file_${index}`"
                    >
                      <a
                        href="#"
                        class="text-danger"
                        style="margin-right: 5px"
                        @click="deleteFile(damage, file)"
                      >
                        <i class="el-icon-close"></i>
                      </a>
                      {{ file.name }}
                    </span>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- <el-table :data="damages" v-if="false">
            <el-table-column label="Damage Part / Panel">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.damage_part_id"
                  clearable
                  filterable
                  @change="addNewRow"
                >
                  <el-option
                    v-for="item in getAvailableParts()"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="Description">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.damage"
                  clearable
                  filterable
                  @change="addNewRow"
                >
                  <el-option
                    v-for="item in damage_descriptions"
                    :value="item.value"
                    :key="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="Action Taken">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.action_required"
                  clearable
                  filterable
                  @change="addNewRow"
                >
                  <el-option
                    v-for="item in action_taken"
                    :value="item.value"
                    :key="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table> -->
        </el-form>
        <div class="el-drawer__footer">
          <el-button size="small" type="primary" @click="saveDamage"
            >Save</el-button
          >
        </div>
      </div>
    </app-drawer>
  </div>
</template>

<script>
import RepairDamage from "@/models/RepairDamage";
import ULD from "@/models/ULD";
import User from "@/models/User";
export default {
  name: "ULD_Damages",

  data() {
    return {
      isLoading: false,
      viewDrawer: false,
      damages: [],
      damageParts: [],
      // damage_descriptions: ULD.damage_descriptions(),
      action_taken: ULD.action_taken(),
      isEdit: false,
      tailor: [],
      welder: []
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    uld() {
      return this.$store.getters["uld/info"];
    },
    damage_descriptions() {
      return this.$store.getters["uld/damageDescriptions"];
    }
  },
  methods: {
    isRole(param) {
      let res = false;
      if (Array.isArray(param) && param.find(o => o == this.user.user_type)) {
        res = true;
      } else {
        if (this.user.user_type == param) {
          res = true;
        }
      }
      return res;
    },
    getAvailableParts() {
      return this.damageParts;
    },
    open(damage) {
      // this.viewDrawer = true;
      this.isEdit = false;
      if (damage) {
        this.damages = [];
        this.isLoading = true;
        this.isEdit = true;
        let params = {
          damage_id: damage.id
        };
        ULD.get_damage_parts(params).then(resp => {
          this.isLoading = false;
          let item = { ...damage, files: [] };
          item.welded_by = resp.data[0].welded_by
            ? parseInt(resp.data[0].welded_by)
            : "";
          item.tailored_by = resp.data[0].tailored_by
            ? parseInt(resp.data[0].tailored_by)
            : "";
          // item.files = resp.data[0].path;
          for (let file of resp.data[0].path) {
            item.files.push({
              ...file,
              url: file.raw
            });
          }
          this.damages.push(item);
        });
      } else {
        this.damages.push({
          damage_part_id: "",
          damage: "",
          action_required: "",
          tailored_by: "",
          welded_by: "",
          user_type: "",
          files: []
        });
      }
      this.$refs.appDrawer.open();
    },
    closeDrawer() {
      this.$refs.appDrawer.close();
      this.damages = [];
    },
    saveDamage() {
      // validate all records
      this.$confirm("Do you want to save these damages?")
        .then(() => {
          let isValid = true;
          if (this.damages.length == 1) {
            let damage = this.damages[0];
            if (!damage.damage_part_id) {
              isValid = false;
            }
          }
          if (!isValid) {
            this.$notify({
              type: "warning",
              message: "No damage to save.",
              position: "bottom-right"
            });
            return false;
          }
          for (let damage of this.damages) {
            if (this.user.user_type != 3) {
              // check only damage desc for supervisor
              if (damage.damage_part_id && !damage.damage) {
                isValid = false;
                this.$notify({
                  type: "warning",
                  message: "Damage Description is required.",
                  position: "bottom-right"
                });
                break;
              }
            } else if (this.user.user_type == 3) {
              // if (
              //   damage.damage_part_id &&
              //   (!damage.damage ||
              //     !damage.action_required ||
              //     !damage.welded_by ||
              //     !damage.tailored_by)
              // ) {
              // only require action required
              if (
                damage.damage_part_id &&
                (!damage.damage || !damage.action_required)
              ) {
                isValid = false;
                this.$notify({
                  type: "warning",
                  message: "Action Taken is required.",
                  position: "bottom-right"
                });
                break;
              }
            }
          }
          if (!isValid) {
            // this.$notify({
            //   type: "warning",
            //   message: "Description and Action Taken are required.",
            //   position: "bottom-right",
            // });
            return false;
          }
          let payload = {
            id: this.uld.id,
            damages: []
          };
          for (let damage of this.damages) {
            let p_damage = { ...damage, path: "" };
            delete p_damage.files;
            if (damage.damage_part_id) {
              let urls = [];
              for (let file of damage.files) {
                urls.push(file.url);
              }
              p_damage.path = urls.join(",");
              if (!p_damage.welded_by) p_damage.welded_by = null;
              if (!p_damage.tailored_by) p_damage.tailored_by = null;

              payload.damages.push(p_damage);
            }
          }
          this.isLoading = true;
          ULD.update(payload).then(() => {
            this.isLoading = false;
            this.closeDrawer();
            this.$store.dispatch("uld/fetch", this.uld.id);
          });
        })
        .catch(() => {});
    },
    library() {
      this.damageParts = [];
      RepairDamage.list({ limit: 99999 }).then(list => {
        this.damageParts = list.data;
      });
      User.list({ user_type: "tailor", limit: 99999 }).then(resp => {
        this.tailor = resp.data;
      });
      User.list({ user_type: "welder", limit: 99999 }).then(resp => {
        this.welder = resp.data;
      });
      // ULD.get_damage_descriptions().then((list) => {
      //   this.damage_descriptions = list;
      // });
    },
    addNewRow() {
      if (this.isEdit) return;
      let latest = this.damages[this.damages.length - 1];
      if (latest.damage_part_id) {
        this.damages.push({
          damage_part_id: "",
          damage: "",
          action_required: "",
          user_type: "",
          tailored_by: "",
          welded_by: "",
          files: []
        });
      }
    },
    checkAvailability(id) {
      let check;
      if (this.uld.id) {
        let damages = this.uld.damages;
        check = damages.find(o => o.damage_part_id == id);
        if (check) return true;
      }
      check = this.damages.find(o => o.damage_part_id == id);
      if (check) return true;
      return false;
    },
    handleUploadSuccess(resp, damage) {
      let res = resp[0],
        file = resp[1];
      // fileList = resp[2];
      let s = file.name.split(".");
      s.pop();
      let filename = s.join("");

      let obj = {
        _file: file,
        name: filename,
        url: res.data.msg
      };
      damage.files.push(obj);
    },
    getImageSrc(file) {
      if ("_file" in file) return URL.createObjectURL(file._file.raw);
      else return "data:image/jpg;base64," + file.path;
    },
    deleteFile(damage, file) {
      if(!this.isRole([3])) damage.files = damage.files.filter(o => o.url != file.url);
    }
    // assignType(damage, type) {
    //   damage.tailored_by = "";
    //   damage.welded_by = "";
    //   damage.user_type = type;
    // }
  },
  mounted() {
    this.library();
    // insert default item
    // this.damages.push({
    //   damage_part_id: "",
    //   damage: "",
    //   action_required: "",
    //   files: []
    // });
  }
};
</script>

<style lang="css" scoped></style>
